<template>
  <div
    class="flex items-center gap-3 bg-white border border-gray-200 rounded-xl px-3.5 py-3 cursor-pointer active:bg-gray-50 md:max-w-72"
  >
    <Avatar
      v-if="member.profileImage"
      :image="member.profileImage"
      shape="circle"
      class="!w-10 !h-10 flex-none"
    />
    <div
      v-else
      class="w-10 h-10 rounded-full flex items-center justify-center font-medium text-sm flex-none"
      :style="avatarStyle(member)"
    >{{ initials(member.fullName) }}</div>

    <div class="flex-1 min-w-0">
      <div class="flex items-center gap-1.5 flex-wrap">
        <span class="text-sm font-medium truncate">{{ member.fullName }}</span>
        <span
          v-if="member.main"
          class="text-[10px] font-semibold text-primary-700 bg-primary-100 px-2 py-0.5 rounded-full"
        >מנהל ראשי</span>
        <span
          v-if="branchCount > 1"
          class="inline-flex items-center gap-1 text-[9.5px] font-semibold text-primary-700 bg-primary-100 px-1.5 py-0.5 rounded-full"
        >
          <i class="pi pi-map-marker text-[8px]" /> {{ branchCount }} סניפים
        </span>
      </div>
      <div class="text-[11.5px] text-gray-500 mt-0.5 truncate">
        {{ servicesCount(member.userId) }} שירותים ·
        {{ branchId ? `${weeklyHours(member.userId, branchId)} שעות בסניף` : `${weeklyHours(member.userId)} שעות/שבוע` }}
      </div>
    </div>

    <i class="pi pi-angle-left text-gray-400 flex-none" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Avatar from 'primevue/avatar';
import { avatarStyle, initials, servicesCount, teamMemberBranchIds, weeklyHours } from './team-utils';

const props = defineProps<{
  member: { userId: string; fullName: string; main?: boolean; profileImage?: string };
  branchId?: string;
}>();

const branchCount = computed(() => teamMemberBranchIds(props.member.userId).length);
</script>
